<template>
  <div class="nodata">
    <img
      :src="langSet == 'cn' ? require('../assets/nodata.png') : require('../assets/nodata01.png')"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 0;
  img {
    width: 180px;
  }
  .txt {
    margin-top: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
}
@media only screen and (max-width: 767px) {
  .nodata {
    padding: 0.58rem 0 0;
    img {
      width: 110px;
    }
    .txt {
      font-weight: 400;
      font-size: 14px;
      margin-top: 25px;
    }
  }
}
</style>